<ng-container *transloco="let t">
  <div class="body-style">
    <div class="container mt-4">
      <div class="p-fluid p-grid p-mt-1">
        <div class="p-col-8 p-md-8 p-pt-0">
          <h2
            class="text-header-upload"
            id="divApplicationStatusValue"
            style="margin-bottom: 10px"
          >
            {{ selectedData?.application?.statusDesc }}
          </h2>
          <p class="text-prepare-upload" id="divApplicationStatusNotification">
            {{ selectedData?.application?.statusRemark }}
          </p>
        </div>
        <div
          class="p-col-4 p-md-4 p-mt-2 p-pt-0"
          style="text-align: right; padding-top: 5px !important"
        >
          <img
            class="doc-upload"
            src="assets/images/doc-upload.png"
            alt=""
            width="32"
          />
        </div>
      </div>

      <div class="card" style="padding-top: 1px">
        <ng-container *ngIf="!isResubmitDocument; else resubmitBlock">
          <!-- บล็อกสำหรับไม่ใช่ Resubmit -->
          <div>
            <p class="text-header-detail-upload">เอกสารประกอบการสมัคร</p>
            <ul>
              <ng-container
                *ngFor="let document of pendingDocumentsList?.documentType"
              >
                <li *ngIf="document.doc_require" class="list-item">
                  {{ document.doc_name }}
                </li>
              </ng-container>
            </ul>
          </div>

          <div class="info-section-line"></div>

          <div *ngIf="documentCountNotRequired > 0" class="p-mt-3">
            <span class="text-header-detail-upload">
              เอกสารเพิ่มโอกาสพิจารณา (ไม่บังคับ)
            </span>

            <span
              *ngIf="documentCountRequired >= 5"
              class="p-pr-3"
              style="float: right; display: flex; align-items: center"
              (click)="showMoreDocumentNotRequired()"
            >
              <img
                *ngIf="!showMoreFlagDocumentNotRequired"
                src="assets/images/icon-up.png"
                alt="up"
                width="24"
              />
              <img
                *ngIf="showMoreFlagDocumentNotRequired"
                src="assets/images/icon-down.png"
                alt="down"
                width="24"
              />
            </span>

            <ul *ngIf="!showMoreFlagDocumentNotRequired" class="p-mb-0">
              <ng-container
                *ngFor="let document of pendingDocumentsList?.documentType"
              >
                <li *ngIf="!document.doc_require" class="list-item">
                  {{ document.doc_name }}
                </li>
              </ng-container>
            </ul>

            <div class="info-section-line p-mt-3"></div>
          </div>
        </ng-container>

        <!-- บล็อกกรณี isResubmitDocument -->
        <ng-template #resubmitBlock>
          <div>
            <p class="text-header-detail-upload">เอกสารประกอบการสมัคร</p>
            <ul>
              <ng-container
                *ngFor="let document of pendingDocumentsList?.documentType"
              >
                <li class="list-item">
                  {{ document.doc_name }}
                </li>
              </ng-container>
            </ul>
          </div>
          <div class="info-section-line"></div>
        </ng-template>

        <div
          class="center-align"
          style="padding-top: 20px; padding-bottom: 20px"
        >
          <span class="center-align">
            <img src="assets/images/sending-apply.png" alt="" width="24" />
          </span>
          <span
            class="center-align text-button-action-upload"
            style="cursor: pointer"
            (click)="onViewDocumentExampleClick()"
          >
            {{ t('appStatus.viewDocumentExample') }}</span
          >
        </div>
      </div>
      <div>
        <div class="card" style="margin-top: 15px; padding-top: 20px">
          <div class="p-fluid p-grid align-top-left">
            <div class="p-col-5 p-md-5" style="padding-bottom: 0px">
              <p class="text-extend-upload">
                {{ t('appStatus.uploadedByDate') }}
              </p>
            </div>
            <div class="p-col-7 p-md-7" style="padding-bottom: 0px">
              <p class="text-time-extend-upload">
                {{
                  selectedData?.application?.followupExpireDate
                    | customThDate: 'dd MMM yyyy':getCurrentLang
                }}
                -
                {{
                  selectedData?.application?.followupExpireDate | date: 'HH:mm'
                }}
              </p>
            </div>

            <div
              class="p-col-12 p-md-12 p-pt-0"
              *ngIf="
                selectedData?.application?.followupExpireCountdown &&
                checkFollowExpiredDay(selectedData?.application)
              "
            >
              <p class="arrive-day p-mt-0 p-mb-0">
                {{ selectedData?.application?.followupExpireCountdown }}
              </p>
            </div>

            <div class="p-col-12 p-md-12">
              <p class="text-extend-upload">
                หากไม่อัปโหลดเอกสารภายในวันที่กำหนด<br />ใบสมัครของคุณจะไม่ได้รับการพิจารณา
              </p>
            </div>
          </div>
          <ng-container *ngIf="!isResubmitDocument">
            <div class="info-section-line"></div>
            <div
              class="center-align"
              style="padding-top: 20px; padding-bottom: 20px"
            >
              <ng-container *ngIf="!isExtendUploadDocument">
                <span class="center-align">
                  <img
                    src="assets/images/extend-doc-upload.png"
                    alt=""
                    width="24"
                  />
                </span>
                <span
                  class="center-align text-button-action-upload"
                  style="cursor: pointer"
                  (click)="openExtendLoanDialog()"
                >
                  {{ t('appStatus.ExtendUploadDocuments') }}</span
                >
              </ng-container>

              <ng-container *ngIf="isExtendUploadDocument">
                <span class="center-align">
                  <img
                    src="assets/images/icon-check-left.png"
                    alt=""
                    width="24"
                  />
                </span>
                <span class="center-align text-button-extended">
                  ขยายเวลาอัปโหลดเอกสาร</span
                >
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>
      <div>
        <div class="card" style="margin-top: 15px; padding-top: 20px">
          <div class="p-fluid p-grid align-top-left">
            <div
              class="p-col-12 p-md-12"
              style="margin-top: -15px; margin-bottom: -25px"
            >
              <p
                class="text-header-detail-upload"
                style="font-size: 18px"
                id="divApplicationStatusProductNameValue"
              >
                {{ selectedData?.application?.productName }}
              </p>
            </div>
            <div class="p-col-12 p-md-12 p-pl-4">
              <span
                class="text-view-upload"
                id="divApplicationStatusDateText"
                >{{ t('appStatus.applicationDate') }}</span
              >
              <span
                class="text-time-extend-upload"
                id="divApplicationStatusDateValue"
              >
                {{
                  selectedData?.application?.submitDate
                    | customThDate: 'dd MMM yyyy':getCurrentLang
                }}
                -
                {{
                  selectedData?.application?.submitDate | date: 'HH:mm'
                }}</span
              >
            </div>

            <div
              class="p-col-4 p-md-4 p-pl-4"
              style="padding-bottom: 0rem"
              id="divApplicationStatusFullNameText"
            >
              <span class="text-view-upload">{{
                t('appStatus.fullName')
              }}</span>
            </div>
            <div
              class="p-col-8 p-md-8 align-left"
              style="padding-bottom: 0rem"
              id="divApplicationStatusFullNameValue"
            >
              <!-- <span class="text-time-extend-upload">
                {{ selectedData?.customer?.firstNameTh }} {{ selectedData?.customer?.lastNameTh }}</span
              > -->
              <span class="text-time-extend-upload fullname-dynamic">
                <span class="first-name">{{
                  selectedData?.customer?.firstNameTh
                }}</span>
                <span class="last-name"
                  >&nbsp;{{ selectedData?.customer?.lastNameTh }}</span
                >
              </span>
            </div>
            <div class="p-col-12 p-md-12 p-mt-2 p-mb-2">
              <div class="info-section-line"></div>
            </div>
          </div>
          <div class="p-fluid p-grid align-top-left">
            <div
              class="p-col-6 p-md-6 p-pl-4"
              style="padding-bottom: 0rem"
              id="divApplicationStatusLoanAmountText"
            >
              <span class="text-view-upload">{{
                t('appStatus.requestLoanAmount')
              }}</span>
            </div>
            <div
              class="p-col-6 p-md-6 p-pl-4 align-left"
              style="padding-bottom: 0rem; color: #015af5"
              id="divApplicationStatusLoanAmountValue"
            >
              <p
                class="text-time-extend-upload"
                style="font-size: 18px; margin-bottom: 0px"
              >
                {{
                  parseToDecimal(selectedData?.application?.requestCreditLimit)
                }}
                <span
                  *ngIf="getCurrentLang === 'th'"
                  style="font-weight: 400; font-size: 16px"
                >
                  บาท
                </span>
              </p>
            </div>
            <div
              class="p-col-6 p-md-6 p-pl-4"
              style="padding-bottom: 0rem"
              id="divApplicationStatusInterestRateText"
            >
              <span class="text-view-upload">{{
                t('appStatus.interestRate')
              }}</span>
            </div>
            <div
              class="p-col-6 p-md-6 p-pl-4 align-left"
              style="padding-bottom: 0rem"
              id="divApplicationStatusInterestRateValue"
            >
              <span class="text-time-extend-upload"
                >{{ selectedData?.application?.offerMaxInterestRate }}%
                <span *ngIf="getCurrentLang === 'th'"> ต่อปี </span>
              </span>
            </div>
            <div
              class="p-col-6 p-md-6 p-pl-4"
              style="padding-bottom: 0rem; line-height: 21px"
              id="divApplicationStatusInstallementText"
            >
              <span class="text-view-upload">
                {{ t('appStatus.installment') }} <br />
                {{ t('appStatus.estimates') }}</span
              >
            </div>
            <div
              class="p-col-6 p-md-6 p-pl-4 align-left"
              style="padding-bottom: 0rem"
              id="divApplicationStatusInstallementValue"
            >
              <span class="loan-amount fw-normal" style="font-family: 'Anuphan'"
                >{{
                  parseToDecimal(
                    selectedData?.application?.maxInstallmentAmount
                  )
                }}
                <span *ngIf="getCurrentLang === 'th'"> บาท </span>
              </span>
            </div>
            <div
              class="p-col-6 p-md-6 p-pl-4"
              style="padding-bottom: 0rem"
              id="divApplicationStatusPaymentTermText"
            >
              <span class="text-view-upload">{{
                t('appStatus.paymentTerms')
              }}</span>
            </div>
            <div
              class="p-col-6 p-md-6 p-pl-4 align-left"
              style="padding-bottom: 0rem"
              id="divApplicationStatusPaymentTermValue"
            >
              <span class="text-time-extend-upload" style="font-weight: 400">
                {{ selectedData?.application?.selectedPaymentTerm }}
                <span *ngIf="getCurrentLang === 'th'">
                  {{ paymentTermEnum.MONTHS_TH }}
                </span>
              </span>
            </div>
            <div
              class="p-col-12 p-md-12 p-pl-4"
              style="padding-bottom: 0rem; line-height: 21px"
              id="divApplicationStatusDescriptionValue"
            >
              <span
                class="text-view-upload"
                [innerHTML]="t('appStatus.installmentAmountPerMonth')"
              >
                {{ t('appStatus.installmentAmountPerMonth') }}</span
              >
            </div>
            <ng-container *ngIf="showMoreFlag">
              <div class="p-col-12 p-md-12 p-mt-2">
                <div class="info-section-line"></div>
              </div>
              <div
                class="p-col-4 p-md-4 p-pl-4"
                style="padding-bottom: 0rem"
                id="divApplicationStatusFeeText"
              >
                <span class="text-view-upload">{{
                  t('appStatus.feeDoc')
                }}</span>
              </div>
              <div
                class="p-col-8 p-md-8 p-pl-4"
                style="padding-bottom: 0rem; text-align: right"
                id="divApplicationStatusFeeValue"
              >
                <p
                  class="text-time-extend-upload"
                  style="font-weight: 400; margin-bottom: 0px"
                >
                  {{ t('appStatus.feeDescriptionUpload') }}
                </p>
              </div>
              <div
                class="p-col-4 p-md-4 p-pl-4"
                style="padding-bottom: 0rem; margin-bottom: -15px"
                id="divApplicationStatusRefNoText"
              >
                <span class="text-view-upload">{{ t('appStatus.refNo') }}</span>
              </div>
              <div
                class="p-col-8 p-md-8 p-pl-4"
                style="
                  padding-bottom: 0rem;
                  text-align: right;
                  margin-bottom: -15px;
                "
                id="divApplicationStatusRefNoValue"
              >
                <p class="text-time-extend-upload" style="font-weight: 400">
                  {{ selectedData?.application?.applicationRef }}
                </p>
              </div>
            </ng-container>
          </div>

          <div class="info-section-line" style="margin-top: 16px"></div>
          <div
            class="center-align"
            style="padding-top: 20px; padding-bottom: 20px; cursor: pointer"
            (click)="showMore()"
            id="seeMoreBtn"
          >
            <span class="center-align text-button-action-view-upload">
              {{ showMoreFlag ? 'ย่อ' : 'ดูเพิ่มเติม' }}
            </span>
            <span class="center-align">
              <img
                *ngIf="!showMoreFlag"
                src="assets/images/icon-down.png"
                alt="down"
                width="24"
              />
              <img
                *ngIf="showMoreFlag"
                src="assets/images/icon-up.png"
                alt="up"
                width="24"
              />
            </span>
          </div>
        </div>
      </div>
      <div class="p-mb-4" id="divApplicationStatusDescriptionValue">
        <h4 class="p-mb-2 p-mt-3 alert-info">
          <span>{{ t('pendingUploadDocuments.alertInfo') }}</span>
          <span class="alert-info-tel">{{
            t('pendingUploadDocuments.alertInfoTel')
          }}</span>
        </h4>
      </div>
    </div>
    <div class="button-container">
      <div class="p-mb-3 open-followup-btn">
        <web-di-ld-button
          [borderradius]="'48px'"
          [background]="'#015AF5'"
          [fontFamily]="'Anuphan'"
          [label]="t('appStatus.viewDocumentBtn')"
          (clickEvt)="openFollowup()"
        ></web-di-ld-button>
      </div>
      <div class="p-mb-2 button-link">
        <p-button
          (click)="cancelApplication()"
          label="{{ t('appStatus.cancelApplicationBtn') }}"
          styleClass="p-button-link underline"
        >
        </p-button>
      </div>
    </div>
  </div>
  <ng-container>
    <p-dialog
      class="dialog-container"
      [(visible)]="extendLoanDialogVisible"
      [modal]="true"
      [showHeader]="false"
    >
      <div class="content-container">
        <div class="image-wrapper">
          <img
            src="assets/images/upload-warning.png"
            alt="upload-warning"
            width="240"
          />
        </div>
        <h3 class="title">
          {{ t('appStatus.extendLoanDialog.title') }}
        </h3>
        <p class="info">
          {{
            t('appStatus.extendLoanDialog.description', {
              extendDay: pendingDocumentsList?.extendDay
            })
          }}
        </p>
        <div class="p-mt-4 p-grid">
          <div class="p-col-6 cancel_btn">
            <web-di-ld-button
              [borderradius]="'48px'"
              [fontFamily]="'Anuphan'"
              [height]="'52px'"
              label="{{ t('appStatus.extendLoanDialog.cancelBtn') }}"
              (clickEvt)="cancelExtendLoanDialog()"
            >
            </web-di-ld-button>
          </div>
          <div class="p-col-6 confirm_btn">
            <web-di-ld-button
              [borderradius]="'48px'"
              [fontFamily]="'Anuphan'"
              [height]="'52px'"
              label="{{ t('appStatus.extendLoanDialog.extendTimeBtn') }}"
              (clickEvt)="extendConfirm()"
            >
            </web-di-ld-button>
          </div>
        </div>
      </div>
    </p-dialog>

    <p-dialog
      class="dialog-container"
      [(visible)]="cancelLoanDialogVisible"
      [modal]="true"
      [showHeader]="false"
    >
      <div class="content-container">
        <h3 class="title-pre-cancel">
          {{ t('appStatus.preCancelLoanDialog.title') }}
        </h3>

        <div class="p-grid">
          <div class="p-col-2" style="text-align-last: center">
            <img
              src="assets/images/pre-cancel-doc-1.png"
              alt="pre-cancel-doc-1"
              width="32"
            />
          </div>
          <div class="p-col-10 p-mt-1">
            <span class="pre-cancel-title"
              >อีกขั้นตอนเดียวจะได้รับวงเงินสินเชื่อ</span
            ><br />
            <span class="pre-cancel-description"
              >เพียงแค่อัปโหลดเอกสาร ก็จะถึงขั้นตอนการ พิจารณาสินเชื่อ</span
            >
          </div>

          <div class="p-col-2" style="text-align-last: center">
            <img
              src="assets/images/pre-cancel-doc-2.png"
              alt="pre-cancel-doc-2"
              width="32"
            />
          </div>
          <div class="p-col-10 p-mt-1">
            <span class="pre-cancel-title">ใบสมัครจะถูกยกเลิก</span><br />
            <span class="pre-cancel-description"
              >หากเปลี่ยนใจต้องการขอสินเชื่อในภายหลัง
              จะต้องสมัครใหม่ตั้งแต่ต้น</span
            >
          </div>
        </div>

        <div class="p-mt-2 p-grid">
          <div class="p-col-12 cancel_btn">
            <web-di-ld-button
              [borderradius]="'48px'"
              [fontFamily]="'Anuphan'"
              [height]="'52px'"
              label="{{ t('appStatus.preCancelLoanDialog.confirmBtn') }}"
              (clickEvt)="cancelConfirmLoanDialog()"
            >
            </web-di-ld-button>
          </div>
          <div class="p-col-12 confirm_btn">
            <web-di-ld-button
              [borderradius]="'48px'"
              [fontFamily]="'Anuphan'"
              [height]="'52px'"
              label="{{ t('appStatus.preCancelLoanDialog.cancelBtn') }}"
              (clickEvt)="cancelLoanDialog()"
            >
            </web-di-ld-button>
          </div>
        </div>
      </div>
    </p-dialog>

    <p-dialog
      class="dialog-container"
      [(visible)]="viewExampleFailDialogVisible"
      [modal]="true"
      [showHeader]="false"
    >
      <div class="content-container">
        <div class="image-wrapper">
          <img
            src="assets/images/view-example-doc-dialog.png"
            alt="upload-warning"
            width="240"
          />
        </div>
        <h3 class="title">
          {{ t('appStatus.viewExampleDocDialog.title') }}
        </h3>
        <p class="info">
          {{
            t('appStatus.viewExampleDocDialog.description', {
              extendDay: pendingDocumentsList?.extendDay
            })
          }}
        </p>
        <div class="p-mt-4 p-grid">
          <div class="p-col-12 confirm_btn">
            <web-di-ld-button
              [borderradius]="'48px'"
              [fontFamily]="'Anuphan'"
              [height]="'52px'"
              label="{{ t('appStatus.viewExampleDocDialog.closeDialog') }}"
              (clickEvt)="closeViewExampleMode()"
            >
            </web-di-ld-button>
          </div>
        </div>
      </div>
    </p-dialog>
  </ng-container>
</ng-container>
<!-- <div class="container">
    <div class="p-d-flex p-ai-center p-jc-center p-d-flex-col">
      <div>
        <img src="assets/images/Upload.png" alt="" width="240px" />
      </div>
      <h3 class="p-m-0 font-20 fw-bold" id="divApplicationStatusValue">
        {{ selectedData?.application?.statusDesc }}
      </h3>
      <p
        class="information-message p-mt-2 p-text-center p-mb-3"
        id="divApplicationStatusNotification"
      >
        {{ selectedData?.application?.statusRemark }}
      </p>
    </div>
    <div class="info-section-line"></div>

    <div class="p-mb-4">
      <h4 class="p-mb-2 p-mt-3">{{ t('pendingUploadDocuments.title') }}</h4>
      <ul class="documents-list" [ngClass]="{ 'dislay-all': isCollapse }">
        <li
          [ngClass]="{ 'dislay-none': documentCount > 3 && i > 2 }"
          *ngFor="
            let document of pendingDocumentsList?.documentType;
            let i = index
          "
          class="list-item"
        >
          {{ document.doc_name }}
        </li>
      </ul>
      <div *ngIf="documentCount > 3">
        <div class="info-section-line p-mt-3 p-mb-2"></div>
        <div class="p-mb-2 button-link">
          <p-button
            (click)="toggleDocList()"
            *ngIf="!isCollapse"
            icon="pi pi-angle-down fix-position"
            iconPos="right"
            label="{{ t('pendingUploadDocuments.viewMore') }}"
            styleClass="p-button-link"
          >
          </p-button>
          <p-button
            (click)="toggleDocList()"
            *ngIf="isCollapse"
            icon="pi pi-angle-up fix-position"
            iconPos="right"
            label="{{ t('pendingUploadDocuments.short') }}"
            styleClass="p-button-link fw-bold"
          >
          </p-button>
        </div>
      </div>
    </div>

    <div class="info-received-card p-p-3 p-mb-2">
      <div class="p-d-flex p-justify-between">
        <div>
          <div class="info-label p-pb-0">
            {{ t('appStatus.uploadedByDate') }}
          </div>
          <div class="info-heading non-padding font-18">
            {{
              selectedData?.application?.followupExpireDate
                | customThDate: 'd MMM yy'
            }}
          </div>
        </div>
        <div
          *ngIf="selectedData?.application?.followupExpireCountdown"
          class="p-d-flex"
        >
          <div
            class="arrive-day p-d-flex p-align-center p-px-2 p-py-1 align-end"
          >
            <img src="assets/images/ic_pending.svg" alt="" width="16px" />
            <div class="p-pl-2">
              {{ selectedData?.application?.followupExpireCountdown }}
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="!isResubmitDocument">
        <div class="info-section-line p-mt-3 p-mb-2"></div>
        <div class="button-link" *ngIf="isExtendUploadDocument === false">
          <p-button
            (click)="openExtendLoanDialog()"
            label="{{ t('appStatus.ExtendUploadDocuments') }}"
            styleClass="p-button-link fw-bold"
          >
          </p-button>
        </div>
        <div
          *ngIf="isExtendUploadDocument === true"
          class="p-d-flex p-jc-center p-align-center color-838383"
        >
          <div class="mt-5px">
            <img
              src="assets/images/ic_check-circle-gray.png"
              alt=""
              width="16px"
              height="16px"
            />
          </div>
          <div class="p-pl-1 extend-text">ขยายเวลาอัปโหลดเอกสารแล้ว</div>
        </div>
      </div>
    </div>
  </div> -->

<!-- <div class="divider"></div>
  <div class="app-details">
    <h4 class="p-mb-3 p-mt-2">
      {{ t('pendingUploadDocuments.productTitle') }}
    </h4>
    <div class="p-grid p-grid-card">
      <div class="p-col-4 info-label" id="divApplicationStatusProductNameText">
        {{ t('appStatus.product') }}
      </div>
      <div class="p-col-8 info-value" id="divApplicationStatusProductNameValue">
        {{ selectedData?.application?.productName }}
      </div>
      <div class="p-col-4 info-label" id="divApplicationStatusFullNameText">
        {{ t('appStatus.fullName') }}
      </div>
      <div class="p-col-8 info-value" id="divApplicationStatusFullNameValue">
        <span *ngIf="getCurrentLang === 'th'">{{
          selectedData?.customer?.fullNameTh
        }}</span>
        <span *ngIf="getCurrentLang === 'en'">{{
          selectedData?.customer?.fullNameTh
        }}</span>
      </div>
    </div>
    <div class="info-section-line p-mt-2 p-mb-3"></div>

    <div>
      <div class="p-grid p-grid-card">
        <div class="p-col-6 info-label" id="divApplicationStatusLoanAmountText">
          {{ t('appStatus.requestLoanAmount') }}
        </div>
        <div
          class="p-col-6 info-value"
          id="divApplicationStatusLoanAmountValue"
        >
          <span class="loan-amount">{{
            parseToDecimal(selectedData?.application?.requestCreditLimit)
          }}</span>
          <span *ngIf="getCurrentLang === 'th'"> บาท </span>
          <span *ngIf="getCurrentLang === 'en'"> THB </span>
        </div>
        <div
          class="p-col-6 info-label"
          id="divApplicationStatusInterestRateText"
        >
          {{ t('appStatus.interestRate') }}
        </div>
        <div
          class="p-col-6 info-value loan-interest"
          id="divApplicationStatusInterestRateValue"
        >
          {{ selectedData?.application?.offerMaxInterestRate }}%
          <span *ngIf="getCurrentLang === 'th'"> ต่อปี </span>
          <span *ngIf="getCurrentLang === 'en'"> per year </span>
        </div>

        <div
          class="p-col-6 info-label"
          id="divApplicationStatusInstallementText"
        >
          {{ t('appStatus.installment') }} <br />
          {{ t('appStatus.estimates') }}
        </div>
        <div
          class="p-col-6 info-value"
          id="divApplicationStatusInstallementValue"
        >
          <span class="loan-amount fw-normal">{{
            parseToDecimal(selectedData?.application?.maxInstallmentAmount)
          }}</span>
          <span *ngIf="getCurrentLang === 'th'"> บาท </span>
          <span *ngIf="getCurrentLang === 'en'"> THB </span>
        </div>

        <div
          class="p-col-6 info-label"
          id="divApplicationStatusPaymentTermText"
        >
          {{ t('appStatus.paymentTerms') }} 
        </div>
        <div
          class="p-col-6 info-value"
          id="divApplicationStatusPaymentTermValue"
        >
          {{ selectedData?.application?.selectedPaymentTerm }}
          <span
            *ngIf="selectedData?.application?.selectedPaymentTermType === 'M'"
          >
            <span *ngIf="getCurrentLang === 'th'">
              {{ paymentTermEnum.MONTHS_TH }}
            </span>
            <span *ngIf="getCurrentLang === 'en'">
              {{ paymentTermEnum.MONTHS_EN }}
            </span>
          </span>
        </div>
        <div
          class="p-col-12 info-label pt-c"
          id="divApplicationStatusDescriptionValue"
        >
          <div class="info-start">
            <img
              class="p-mr-2 info-icon"
              src="/assets/images/foundation-icon-simple-system-information.svg"
              alt=""
              width="16px"
            />
          </div>
          <div>{{ t('appStatus.installmentAmountPerMonth') }}</div>
        </div>
      </div>
      <div class="info-section-line p-mb-2 p-mt-2"></div>

      <div class="p-mb-2 button-link" *ngIf="!isListCollapse">
        <p-button
          (click)="toggleList()"
          icon="pi pi-angle-down fix-position"
          iconPos="right"
          label="{{ t('appStatus.seeMore') }}"
          styleClass="p-button-link"
          id="seeMoreBtn"
        >
        </p-button>
      </div>

      <div *ngIf="isListCollapse">
        <div class="p-grid p-grid-card p-mt-3 p-mb-2">
          <div class="p-col-6 info-label" id="divApplicationStatusFeeText">
            {{ t('appStatus.fee') }}
          </div>
          <div class="p-col-6 info-value" id="divApplicationStatusFeeValue">
            {{ t('appStatus.percent') }}
            {{ t('appStatus.feeDescription') }}
          </div>
        </div>
        <div class="info-section-line p-mb-3"></div>
        <div class="p-grid p-grid-card p-mb-2">
          <div class="p-col-6 info-label" id="divApplicationStatusDateText">
            {{ t('appStatus.applicationDate') }}
          </div>
          <div class="p-col-6 info-value" id="divApplicationStatusDateValue">
            {{
              selectedData?.application?.submitDate
                | customThDate: 'd MMM yy':getCurrentLang
            }}
            {{ selectedData?.application?.submitDate | date: 'HH:mm' }}
          </div>
        </div>
        <div class="p-d-flex p-jc-between p-ai-center">
          <div class="info-label" id="divApplicationStatusRefNoText">
            {{ t('appStatus.refNo') }}
          </div>
          <div class="info-value" id="divApplicationStatusRefNoValue">
            {{ selectedData?.application?.applicationRef }}
          </div>
        </div>
        <div class="info-section-line"></div>
      </div>

      <div class="p-mb-2 button-link" *ngIf="isListCollapse">
        <p-button
          (click)="toggleList()"
          icon="pi pi-angle-up fix-position"
          iconPos="right"
          label="{{ t('appStatus.short') }}"
          styleClass="p-button-link"
          id="seeMoreBtn"
        >
        </p-button>
      </div>

      <div class="p-grid p-grid-card info-alert-card p-mt-2">
        <div
          class="p-col-12 info-label"
          id="divApplicationStatusDescriptionValue"
        >
          <div class="info-start">
            <img
              class="p-mr-2 info-icon"
              src="/assets/images/foundation-icon-simple-system-information-yellow.svg"
              alt=""
              width="16px"
            />
          </div>
          <div class="info-alert-text">
            {{ t('pendingUploadDocuments.alertInfo') }}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="button-container">
    <div class="p-mb-3">
      <web-di-ld-button
        [label]="t('appStatus.viewDocumentBtn')"
        (clickEvt)="openFollowup()"
      ></web-di-ld-button>
    </div>
    <div class="p-mb-2 button-link">
      <p-button
        (click)="cancelApplication()"
        label="{{ t('appStatus.cancelApplicationBtn') }}"
        styleClass="p-button-link underline"
      >
      </p-button>
    </div>
  </div>

  <ng-container>
    <p-dialog
      class="dialog-container"
      [(visible)]="extendLoanDialogVisible"
      [modal]="true"
      [showHeader]="false"
    >
      <div class="content-container p-mt-2">
        <h3 class="title">
          {{ t('appStatus.extendLoanDialog.title') }}
        </h3>
        <p class="info">
          {{
            t('appStatus.extendLoanDialog.description', {
              extendDay: pendingDocumentsList?.extendDay
            })
          }}
        </p>
        <div class="p-mt-4 p-grid">
          <div class="p-col-6 cancel_btn">
            <web-di-ld-button
              label="{{ t('appStatus.extendLoanDialog.cancelBtn') }}"
              (clickEvt)="cancelExtendLoanDialog()"
            >
            </web-di-ld-button>
          </div>
          <div class="p-col-6">
            <web-di-ld-button
              label="{{ t('appStatus.extendLoanDialog.extendTimeBtn') }}"
              (clickEvt)="extendConfirm()"
            >
            </web-di-ld-button>
          </div>
        </div>
      </div>
    </p-dialog>
  </ng-container> -->
